import { apiClientV2 } from '@/services/rest-api/apiClient'

const baseURL = process.env.VUE_APP_API_VMS_URL

const appendPrefixUrl = (prefixUrl = {}, url) =>
  [
    `/vendor/${prefixUrl.vendorId}`,
    `/contract/${prefixUrl.contractId}`,
    `/version/${prefixUrl.versionId}`,
    `${url}`,
  ].join('')

export const get = async (prefixUrl) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: appendPrefixUrl(prefixUrl, '/rates'),
    // TODO: When BE is fixed, remove this resourceful params
    params: {
      limit: 1000,
      page: 1,
    },
  })

  return response?.data
}

export const show = async (prefixUrl = {}, ratesId) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: appendPrefixUrl(prefixUrl, `/rates/${ratesId}`),
  })

  return response?.data
}

export const store = async (prefixUrl = {}, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: appendPrefixUrl(prefixUrl, `/rates`),
    data,
  })

  return response?.data
}

export const update = async (prefixUrl = {}, ratesId, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: appendPrefixUrl(prefixUrl, `/rates/${ratesId}`),
    data,
  })

  // If no data but status is 200
  if (!response?.data && String(response?.status).startsWith('2')) {
    return 'OK'
  }

  return response?.data
}

export const deleteSingle = async (prefixUrl = {}, ratesId) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: appendPrefixUrl(prefixUrl, `/rates/${ratesId}`),
  })

  // If no data but status is 200
  if (!response?.data && String(response?.status).startsWith('2')) {
    return 'OK'
  }

  return response?.data
}
